// extracted by mini-css-extract-plugin
export default {"scheduledText":"DeliveryTimeText_scheduledText__dXZY1","firstCap":"DeliveryTimeText_firstCap__AnpQ0"};